import { render, staticRenderFns } from "./Emballage.vue?vue&type=template&id=7c085d04&"
import script from "./Emballage.vue?vue&type=script&lang=ts&"
export * from "./Emballage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports